import Insight from "../insightClass";
import React from "react";
import { insight95Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight095 = new Insight(
  "16 February 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight95Media[0],
    alt: "offshore wind farm",
  },
  "Global Offshore Wind Weekly (2026-02-16)",
  "",
  `On 10 February 2026, the UK government officially granted the Development Consent Order (DCO) for the Outer Dowsing offshore wind project. Developed as a joint venture between Corio Generation and TotalEnergies, this 1.5 GW development is positioned as a flagship project from the UK’s Round 4 seabed leasing programme.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-02-16)</h1>
    <h2></h2>
    <p className="article-date">16 February 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. UK: Outer Dowsing (1.5 GW) Secures Development Consent Order (DCO)
    </h3>
    <p>
      On 10 February 2026, the UK government officially granted the Development
      Consent Order (DCO) for the Outer Dowsing offshore wind project. Developed
      as a joint venture between Corio Generation and TotalEnergies, this 1.5 GW
      development is positioned as a flagship project from the UK’s Round 4
      seabed leasing programme.
    </p>
    <p>
      Located approximately 54 km off the Lincolnshire coast, the project is
      authorised to install up to 100 next-generation wind turbines. The
      approved electrical infrastructure includes a landfall site at Anderby
      Marsh, north of Skegness, with underground cabling crossing South
      Lincolnshire to connect to a new onshore substation at Surfleet Marsh.
    </p>
    <p>
      The DCO approval concludes a rigorous examination process that faced
      delays, including requests for additional environmental evidence related
      to the Habitats Regulations. With this legal milestone achieved, the
      project can now progress more decisively toward its final investment
      decision (FID) and supply-chain commitment phase.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Securing a DCO is the single most important de-risking event in the UK
      offshore wind lifecycle. In a market where planning risk materially
      influences the cost of capital, removing this hurdle enables developers to
      shift from “permitting mode” into “execution mode”.
    </p>
    <p>
      That said, Outer Dowsing’s challenge now moves into the delivery phase.
      With ongoing supply-chain tightness and long grid connection queues,
      project performance will depend on (i) securing Tier-1 installation
      capacity, (ii) managing complex onshore interfaces, and (iii) maintaining
      cost discipline under volatile contracting conditions. As the UK targets a
      fully decarbonised power system by 2030, Outer Dowsing becomes not only a
      generation asset but also a practical test of the UK’s ability to deliver
      multi-gigawatt projects at pace under real-world constraints.
    </p>
    <h3>
      2. UK: Hornsea 3 Foundation Campaign Gains Momentum as First XXL Monopiles
      Arrive
    </h3>
    <p>
      The world’s largest single offshore wind farm, Hornsea 3 (2.9 GW), reached
      a major logistical milestone on 11 February 2026 with the arrival of its
      first foundations at the Port of Teesworks. A first batch of six XXL
      monopiles, fabricated by Haizea Wind Group in Bilbao, Spain, was delivered
      via heavy-lift shipping logistics, supported by specialist port-handling
      capability.
    </p>
    <p>
      These units are exceptionally large: each weighs approximately 1,670
      tonnes, measures around 90 metres in length, and reaches up to 11 metres
      in base diameter. The transportation and installation scope is being
      managed by Cadeler, with specialist support for port-side heavy logistics.
    </p>
    <p>
      Hornsea 3 is scheduled to deploy 197 Siemens Gamesa 14 MW turbines around
      160 km off the Yorkshire coast. With offshore works set to ramp up through
      2026, the arrival of foundations marks the transition into the most
      capital-intensive stage of the project, with full commercial operation
      targeted for 2027.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The arrival of XXL monopiles signals Hornsea 3’s transition from
      contractual commitment to physical industrial execution. At this scale,
      logistics and installation sequencing become the primary risk variables.
      Foundation weights of ~1,670 tonnes push the limits of port handling,
      marshalling efficiency, and installation vessel capability—meaning
      schedule slippage can rapidly translate into material cost exposure.
    </p>
    <p>
      For developers and contractors, this phase requires near-zero tolerance
      for quality defects, coating damage, flange issues, or transport-induced
      deformation. In addition, vessel availability remains structurally tight
      globally, making early capacity lock-in a decisive advantage.
    </p>
    <p>
      Hornsea 3 will likely set a benchmark for gigascale offshore wind
      delivery: it is less a technology story and more an industrial systems
      story—where serialised manufacturing, predictable logistics, and
      disciplined interface management determine whether financial performance
      is preserved.
    </p>
    <h3>3. UK: Latest Renewable Auction Results Reinforce Delivery Pressure</h3>
    <p>
      On 10 February 2026, the UK government published results from Allocation
      Round 7 (AR7) for onshore wind, solar, and tidal stream projects. Building
      on capacity announced earlier in the round, AR7’s volume adds further
      momentum to the UK’s wider clean power trajectory.
    </p>
    <p>
      While this announcement is not exclusively offshore wind-focused, its
      impact is system-wide. The scale of contracted capacity increases pressure
      on grid connection availability, delivery resources, and supply-chain
      throughput—factors that directly influence offshore wind schedules and
      risk profiles.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      AR7 underscores a UK reality: securing contracted capacity is only the
      starting point. The binding constraint is increasingly delivery—especially
      grid connection timing, transmission reinforcement, and competition for
      skilled labour, port throughput, and specialist equipment.
    </p>
    <p>
      As pipeline volumes increase, “buildability” becomes the differentiator.
      Projects with secured grid strategies, resilient contractor ecosystems,
      and credible construction sequencing will be better positioned to preserve
      schedule integrity and financial performance.
    </p>
    <p>
      WeBridge expects delivery discipline to become the core competitive
      advantage in the UK market over the next cycle. Policy success will
      increasingly be judged not by award volumes, but by how effectively those
      volumes translate from paper commitments into operational power-producing
      assets.
    </p>
    <h3>
      4. Germany: Offshore Wind Fed 26.1 TWh of Electricity into the Grid in
      2025
    </h3>
    <p>
      Germany’s offshore wind sector maintained robust performance in 2025,
      contributing a total of 26.1 TWh of clean electricity to the national
      grid, according to annual figures published by transmission system
      operator TenneT.
    </p>
    <p>
      The geographic split underscores the North Sea’s dominance: the German
      North Sea delivered 20.8 TWh, while the Baltic Sea contributed 5.38 TWh.
      Offshore output played a stabilising role within Germany’s broader energy
      transition, complementing more variable onshore wind production, which
      totalled 106.5 TWh.
    </p>
    <p>
      While total offshore generation in absolute TWh terms remained broadly
      consistent with 2024, offshore wind increased its relative importance
      within the national wind mix. North Sea offshore wind accounted for 15.7%
      of Germany’s total wind output in 2025, up from 13.86% in the previous
      year.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      TenneT’s 2025 figures highlight a shift from “capacity build-out” to
      “operational contribution”. Even with stable total TWh, offshore wind’s
      growing share suggests improved utilisation, reliability, and system value
      compared with onshore wind in a year shaped by price volatility and
      congestion.
    </p>
    <p>
      However, a plateau in total offshore output also signals a looming
      constraint: grid connection expansion must stay ahead of new project
      volumes. Germany’s ambition to reach 30 GW by 2030 will require rapid
      acceleration in high-voltage direct current (HVDC) converter platforms and
      onshore cable corridors—without which additional generation cannot be
      efficiently integrated.
    </p>
    <p>
      In practice, offshore wind in Germany is increasingly limited not by wind
      resource, but by transmission build pace and HVDC supply-chain throughput.
      Unlocking Baltic potential and balancing North Sea load will also become
      more important for system resilience as volumes rise.
    </p>
    <h3>
      5. Europe: Google Signs a 15-Year Offshore Wind PPA Linked to Germany’s He
      Dreiht
    </h3>
    <p>
      Google has signed a 15-year Power Purchase Agreement (PPA) with EnBW,
      covering 100 MW of capacity from the 960 MW He Dreiht offshore wind farm
      in the German North Sea.
    </p>
    <p>
      The project is located approximately 85 km northwest of the island of
      Borkum and is under construction. The agreement supports Google’s broader
      ambition to operate on 24/7 carbon-free energy (CFE) by 2030, increasingly
      aligning electricity procurement with real-time demand profiles.
    </p>
    <p>
      He Dreiht has attracted multiple corporate offtakers, reflecting the
      growing role of long-tenor corporate PPAs in supporting offshore wind
      project economics as subsidy frameworks evolve.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      A 15-year tenor is commercially significant: it anchors a portion of
      project revenues to a creditworthy counterparty and strengthens
      bankability, which can improve financing terms and enable more efficient
      capital structures.
    </p>
    <p>
      This deal reflects a structural trend: as public subsidy reliance
      declines, large corporates—particularly energy-intensive digital
      infrastructure players—are becoming material contributors to revenue
      certainty and financing confidence for offshore wind.
    </p>
    <p>
      We expect PPA structures to evolve further, with more sophisticated
      designs that incorporate shaping, hourly matching, portfolio aggregation,
      and potentially storage-enabled products to better meet corporate
      procurement requirements and system balancing needs.
    </p>
    <h3>6. Europe: France Revises Offshore Wind Target to 15 GW by 2035</h3>
    <p>
      France has published an updated energy planning framework that revises its
      2035 offshore wind target to 15 GW, down from the 18 GW level proposed
      during consultation.
    </p>
    <p>
      The adjustment forms part of a broader recalibration of the national power
      mix, reflecting revised electricity demand expectations and renewed
      emphasis on nuclear generation. The plan also adjusts wider wind and solar
      ambitions, signalling a more cautious trajectory for renewable build-out,
      while maintaining offshore wind as a strategic component of the long-term
      decarbonisation pathway.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      Even a modest national target reduction can ripple across the offshore
      wind supply chain. Long-term volume visibility underpins investment in
      ports, factories, vessels, and workforce capability; any change in
      expected auction cadence can influence how suppliers and developers
      allocate capital.
    </p>
    <p>
      This should be read as consolidation rather than retreat. Offshore wind in
      France will increasingly compete not only on LCOE but on system value:
      grid integration cost, delivery certainty, industrial contribution, and
      compatibility with a nuclear-heavy generation mix.
    </p>
    <p>
      Going forward, competitive advantage in the French market may shift from
      “scale pursuit” toward “system integration excellence”, where credible
      execution plans and demonstrable industrial impact weigh more heavily in
      investment decisions.
    </p>
    <h3>
      7. United States: Federal Government to Appeal Rulings Allowing Projects
      to Resume
    </h3>
    <p>
      In early February 2026, the US Department of the Interior (DOI) announced
      plans to appeal federal court rulings that granted preliminary injunctions
      allowing several offshore wind projects to resume construction.
    </p>
    <p>
      Affected projects include Coastal Virginia Offshore Wind (CVOW), Empire
      Wind 1, Revolution Wind, Sunrise Wind, and Vineyard Wind 1. These projects
      were halted in December 2025 by stop-work orders citing national security
      concerns, including potential impacts on radar and sonar systems.
    </p>
    <p>
      Although the court decisions enabled developers to recommence work, the
      government’s appeal indicates continued legal uncertainty—particularly
      consequential for projects nearing completion.
    </p>
    <p>
      <b>WeBridge Insights</b>
    </p>
    <p>
      The defining issue here is regulatory volatility. Stop–start policy and
      litigation-driven project control creates outsized risk in
      construction-phase assets, generating remobilisation costs, vessel standby
      liabilities, and schedule compression that can erode project economics
      even if completion ultimately proceeds.
    </p>
    <p>
      For international investors and suppliers, this uncertainty raises risk
      premiums and can weaken confidence in long-term market stability. It can
      also influence vessel allocation decisions, with scarce installation
      capacity potentially prioritised toward more predictable jurisdictions.
    </p>
    <p>
      In response, developers will likely strengthen change-in-law protections,
      maintain larger contingencies, and diversify contracting strategies. The
      US experience reinforces a critical lesson: resource quality alone does
      not secure capital—policy stability and permitting certainty remain
      fundamental to bankable offshore wind markets.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
